// client/src/api/orderApi.js - API des commandes au drive
import api from './api';

// Passer une commande au drive
export const placeOrder = async (shoppingListId, provider) => {
  const response = await api.post('/api/orders', { shoppingListId, provider });
  return response.data;
};

// Vérifier le statut d'une commande
export const checkOrderStatus = async (provider, orderId) => {
  const response = await api.get(`/api/orders/${provider}/${orderId}`);
  return response.data;
};